import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "xmlns": "http://www.w3.org/2000/svg", "width": "14", "height": "14", "viewBox": "0 0 14 14", "fill": "none" } }, [_c("circle", { staticStyle: { "fill": "color(display-p3 1 0.3922 0.2392)", "fill-opacity": "1" }, attrs: { "cx": "7.00781", "cy": "7", "r": "7", "fill": "#FF643D" } }), _c("path", { staticStyle: { "stroke": "white", "stroke-opacity": "1" }, attrs: { "d": "M10 3.99989L3.99936 10.0005", "stroke": "white", "stroke-width": "1.5" } }), _c("path", { staticStyle: { "stroke": "white", "stroke-opacity": "1" }, attrs: { "d": "M4 3.99989L10.0006 10.0005", "stroke": "white", "stroke-width": "1.5" } })]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const UnSupportIcon = __component__.exports;
export {
  UnSupportIcon as default
};
